export default __webpack_public_path__ + "assets/profile_picture1.png";